import Label from "components/Label/Label";
import React, { FC, useEffect, useState } from "react";
import Avatar from "shared/Avatar/Avatar";
import Input from "shared/Input/Input";
import CommonLayout from "./CommonLayout";
import { Helmet } from "react-helmet";
import useFetch from "hooks/useFetch";
import config from "config.json";
import QRCode from "qrcode.react"; 
import DocumentationAlert from "components/Alert/DocumentationAlert";
import AccountDocuments from "./AccountDocuments";
import EditUserPasswordModal from "components/Modal/editUserPasswordModal";
import EditUserData from "components/Modal/editUserData";
import { useNavigate } from "react-router-dom";

export interface AccountPageProps {
  className?: string;
}

interface User {
  id: number;
  firstname: string;
  lastname: string;
  document: string;
  mail: string;
  phones: Phone[];
  fecha_nacimiento: string;
  observations: string;
  semaphore_status: number;
}

interface Phone {
  phone_number: string;
  active: boolean;
}

const AccountPage: FC<AccountPageProps> = ({ className = "" }) => {

  const [userData, setUserData] = useState<User | null>(null);

  const [isCheckedPassword, setIsCheckedPassword] = useState(false);
  const [isEditUserModal, setIsEditUserModal] = useState(false)
  const [isEditUserPasswordModal, setIsEditUserPasswordModal] = useState(false)

  const [showQr, setShowQr] = useState(false)
  const router = useNavigate();
  const handleGoDocumentation = () => {

    router('/account-documents');
  
};

  const handleChangeCheckPassword = () => {
    setIsCheckedPassword(prev => !prev);
  };

  const { data, error, isLoading, fetchData } = useFetch<User>(
    'GET', `${config.backend_url}/authe/token`,
    {},
    { 'Content-Type': 'application/json', 'SetiaAuthorization': `${sessionStorage.getItem('user_token')}` }
  );

  useEffect(() => {
    if (data?.firstname != null) {
      setUserData(data);
    }
  }, [data]);

  useEffect(() => {
    console.log(error);
  }, [error]);

  useEffect(() => {
    fetchData();
  }, []);

  if (userData != null) {

    let dia = userData.fecha_nacimiento.substring(8, 10);
    let mes = userData.fecha_nacimiento.substring(5, 7);
    let anio = userData.fecha_nacimiento.substring(0, 4);

    console.log('dia  ', dia, ' mes ', mes, ' anio ', anio);

    const qrUrl = `https://ww.fire-bots.com/pileta_ezeiza/credencial_turismo.php?txtDni=${userData.document}&cboDia=${dia}&cboMes=${mes}&cboAno=${anio}`;

    return (
      <div className={`nc-AccountPage ${className}`} data-nc-id="AccountPage">
        <EditUserData
          isModalOpen={isEditUserModal}
          handleModalClose={() => {setIsEditUserModal(false)}}
          userData={userData}
        />
        <EditUserPasswordModal
          message="prueba"
          title="Editar contraseña"
          isModalOpen={isEditUserPasswordModal}
          handleModalClose={() => {setIsEditUserPasswordModal(false)}}
          userData={userData}
        />
        <Helmet>
          <title>Mi cuenta - Setia turismo</title>
        </Helmet>
        <DocumentationAlert />
        <CommonLayout>
          <div className="space-y-6 sm:space-y-8">
            {/* HEADING */}
            
            <h2 className="text-3xl font-semibold">Mis datos y credencial</h2>
            <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>

            {/* QR en versión móvil */}
            <div className="block md:hidden text-center">
              <h3 className="text-xl font-semibold mb-4">Credencial:</h3>
              {
                showQr &&
                <>
                  <div className="mb-6 border border-neutral-200 dark:border-neutral-700 rounded-3xl p-4 flex justify-center">
                    <QRCode value={qrUrl} size={250} />
                  </div>
                  <button onClick={() => setShowQr(false)} className="bg-blue-500 hover:bg-blue-700 text-white py-2 px-4 rounded-full focus:outline-none focus:shadow-outline">
                    Ocultar QR
                  </button>
                </>
              }
              {
                !showQr &&
                <button onClick={() => setShowQr(true)} className="bg-blue-500 hover:bg-blue-700 text-white py-2 px-4 rounded-full focus:outline-none focus:shadow-outline">
                  Ver QR
                </button>
              }
              
            </div>

            <div className="flex flex-col md:flex-row">
              <div className="flex-shrink-0 flex items-start">
                <div className="relative rounded-full overflow-hidden flex">
                  <input
                    type="file"
                    className="absolute inset-0 opacity-0 cursor-pointer"
                  />
                </div>
              </div>
              <div className="flex-grow lg:flex lg:flex-wrap mt-10 md:mt-0 md:pl-16 max-w-3xl space-y-6 ">
                <div className="lg:w-1/2 lg:mt-6 lg:p-2">
                  <Label>Nombre</Label>
                  <Input disabled className="mt-1.5" defaultValue={userData.firstname} />
                </div>
                <div className="lg:w-1/2 lg:p-2">
                  <Label>Apellido</Label>
                  <Input className="mt-1.5" disabled defaultValue={userData.lastname} />
                </div>
                <div className="lg:w-1/2 lg:p-2">
                  <Label>N° de Documento</Label>
                  <Input className="mt-1.5" disabled defaultValue={userData.document} />
                </div>
                <div className="lg:w-1/2 lg:p-2">
                  <Label>Mail</Label>
                  <Input className="mt-1.5" disabled defaultValue={userData.mail} />
                </div>
                <div className="lg:w-1/2 lg:p-2">
                  <Label>Numero de telefono</Label>
                  <Input className="mt-1.5" disabled defaultValue={userData.phones[0].phone_number} />
                </div>
                <div className="lg:w-1/2 lg:p-2">
                  <Label>Fecha de nacimiento</Label>
                  <Input className="mt-1.5" disabled defaultValue={userData.fecha_nacimiento} />
                </div>
                {/* <div className="lg:w-1/2 lg:p-2">
                  <Label>Contraseña</Label>
                  <Input className="mt-1.5" disabled defaultValue={"prueba"} type={isCheckedPassword ? "text" : "password"} />
                  <label className="flex items-center m-1">
                    <input
                      type="checkbox"
                      checked={isCheckedPassword}
                      onChange={handleChangeCheckPassword}
                      className="mr-2"
                    />
                    Mostrar contraseña
                  </label>
                </div> */}
              </div>

              {/* QR en versión desktop */}
              <div className=" ml-auto hidden md:block text-center md:pl-16">
                <h3 className="text-xl font-semibold mb-4">Credencial:</h3>
                <div className="border border-neutral-200 dark:border-neutral-700 rounded-3xl p-4 flex justify-center">
                <QRCode value={qrUrl} size={250} />
                </div>
              </div>
            </div>
            <div className="space-y-4 md:pl-16 md:space-x-2">
              {/* <button
                className="w-full md:w-40 bg-blue-600 text-white font-medium text-sm py-2 px-4 rounded-full cursor-pointer hover:bg-blue-800"
                onClick={() => {setIsEditUserModal(true)}}
              >
                Editar datos
              </button> */}
              <button
                className="w-full md:w-40 bg-blue-600 text-white font-medium text-sm py-2 px-4 rounded-full cursor-pointer hover:bg-blue-800"
                onClick={() => {setIsEditUserPasswordModal(true)}}
              >
                Editar contraseña
              </button>

              <button
                className="w-full md:w-52 bg-blue-600 text-white font-medium text-sm py-2 px-4 rounded-full cursor-pointer hover:bg-blue-800"
                onClick={handleGoDocumentation}
              >
                Mi documentación
              </button>
            </div>
            {/* <div>
              <h2 className="text-3xl font-semibold">Mis documentos</h2>
              <AccountDocuments />
            </div> */}
          </div>
        </CommonLayout>
      </div>
    );

  } else {
    return null;
  }

};

export default AccountPage;